import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { get, post } from "../../utils/apiManager";
import { baseURL } from "../../config/config";
import { toast } from "react-toastify";
import Swal from 'sweetalert2';
import Pagination from 'react-js-pagination';
import { useForm } from "react-hook-form";
import SuccessModal from "../../components/SuccessModal";

const Index = () => {
  const { register, handleSubmit, getValues, setValue, reset } = useForm();
  const Navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const [allTemplates, setAllTemplates] = useState([]);
  const [count, setCount] = useState(0);
  const [pageData, setPageData] = useState({
    page: parseInt(searchParams.get('page')) || 1,
    perPage: parseInt(searchParams.get('perPage')) || 25,
    searchItem: searchParams.get('searchItem') || "",
  });
  const [modalData, setModalData] = useState({ message: "", show: false });

  useEffect(() => { getAllEmailTemplate(); }, [pageData]);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const page = parseInt(params.get('page')) || 1;
    const perPage = parseInt(params.get('perPage')) || 25;
    const searchItem = params.get('searchItem') || "";
    setPageData(prev => {
      if (prev.page === page && prev.perPage === perPage && prev.searchItem === searchItem) {
        return prev;
      }
      return { page, perPage, searchItem };
    });
    if (searchItem) setValue("companyName", searchItem);
  }, [location.search]);

  const getAllEmailTemplate = () => {
    get(`/email-template/all?page=${pageData.page}&perPage=${pageData.perPage}&searchItem=${getValues("companyName") || ""}`)
      .then((res) => { setAllTemplates(res?.data || []); setCount(res?.pages || 0); })
      .catch((err) => console.log(err));
  };

  const changeStatus = (id, status) => {
    post(`${baseURL}/email-template/status`, { id, status: !status })
      .then((res) => { if (res?.status) { setModalData({ message: res.message, show: true }); getAllEmailTemplate(); } else toast.error(res?.message); })
      .catch((err) => toast.error(err?.response?.data?.error));
  };

  const deleteHandler = (id) => {
    Swal.fire({ title: 'Are you sure?', text: 'This will delete the email template.', icon: 'warning', showCancelButton: true, confirmButtonColor: '#AD2429', cancelButtonColor: '#6b7a99', confirmButtonText: 'Yes, delete it!' })
      .then((result) => {
        if (result.isConfirmed) {
          post(`${baseURL}/email-template/delete`, { id })
            .then((res) => { if (res?.status) { setModalData({ message: res.message, show: true }); getAllEmailTemplate(); } else toast.error(res?.message); })
            .catch((err) => toast.error(err?.response?.data?.error));
        }
      });
  };

  const updateURL = (newPageData) => {
    const params = new URLSearchParams();
    if (newPageData.page) params.set('page', newPageData.page);
    if (newPageData.perPage) params.set('perPage', newPageData.perPage);
    if (newPageData.searchItem) params.set('searchItem', newPageData.searchItem);
    else params.delete('searchItem');
    Navigate(`?${params.toString()}`, { replace: false });
  };

  const onSubmit = () => {
    const newPageData = { ...pageData, page: 1, searchItem: getValues("companyName") };
    updateURL(newPageData);
    setPageData(newPageData);
  };

  const clearSearch = () => {
    setValue("companyName", "");
    const newPageData = { ...pageData, page: 1, searchItem: "" };
    updateURL(newPageData);
  };

  const pill = (active) => (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4, padding: '3px 9px', borderRadius: 100, fontSize: 11, fontWeight: 700, background: active ? '#dcfce7' : '#fee2e2', color: active ? '#15803d' : '#b91c1c' }}>
      <span style={{ fontSize: 7 }}>●</span>{active ? 'Active' : 'Inactive'}
    </span>
  );

  const thS = { padding: '10px 14px', fontSize: 11, fontWeight: 700, letterSpacing: '0.07em', textTransform: 'uppercase', color: '#9aa5c0', textAlign: 'left', borderBottom: '1px solid #edf0f7', background: '#f8f9fc', whiteSpace: 'nowrap' };
  const tdS = { padding: '12px 14px', fontSize: 14, color: '#3a4a6a', borderBottom: '1px solid #f0f2f8', verticalAlign: 'middle' };

  return (
    <div style={{ fontFamily: "'Segoe UI', system-ui, sans-serif" }}>
      <div style={{ background: '#fff', borderRadius: 14, border: '1px solid #edf0f7', boxShadow: '0 1px 4px rgba(26,39,68,.05)', overflow: 'hidden' }}>

        {/* Header */}
        <div style={{ padding: '18px 24px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid #edf0f7' }}>
          <div>
            <h3 style={{ fontSize: 16, fontWeight: 700, color: '#0a1628', margin: 0 }}>Email Templates</h3>
            <p style={{ fontSize: 13, color: '#9aa5c0', margin: '3px 0 0' }}>System-wide notification email templates</p>
          </div>
          <Link to="/admin/email/add" style={{ textDecoration: 'none' }}>
            <button style={{ background: '#AD2429', color: '#fff', border: 'none', borderRadius: 8, padding: '9px 18px', fontSize: 13, fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit' }}>+ Add Email</button>
          </Link>
        </div>

        {/* Search */}
        <div style={{ padding: '12px 24px', borderBottom: '1px solid #edf0f7', display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
          <input placeholder="Search templates..." {...register("companyName")} style={{ padding: '8px 14px', borderRadius: 8, border: '1px solid #e2e8f0', fontSize: 14, color: '#0a1628', outline: 'none', width: 240, fontFamily: 'inherit' }} />
          <button onClick={onSubmit} style={{ background: '#1a2744', color: '#fff', border: 'none', borderRadius: 8, padding: '8px 16px', fontSize: 13, fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit' }}>Search</button>
          <button onClick={clearSearch} style={{ background: '#f0f2f8', color: '#5a6a8a', border: 'none', borderRadius: 8, padding: '8px 16px', fontSize: 13, fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit' }}>Clear</button>
        </div>

        {/* Table */}
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr>{['Title', 'Slug', 'Subject', 'Status', 'Actions'].map(h => <th key={h} style={thS}>{h}</th>)}</tr>
            </thead>
            <tbody>
              {allTemplates?.length > 0 ? allTemplates.map((item) => (
                <tr key={item._id} onMouseEnter={e => e.currentTarget.style.background = '#fafbfd'} onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
                  <td style={{ ...tdS, fontWeight: 600, color: '#0a1628' }}>{item?.title}</td>
                  <td style={{ ...tdS, fontSize: 12 }}>
                    <span style={{ background: '#f0f2f8', color: '#5a6a8a', padding: '2px 8px', borderRadius: 4, fontFamily: 'monospace' }}>{item?.slug}</span>
                  </td>
                  <td style={{ ...tdS, color: '#6b7a99' }}>{item?.subject}</td>
                  <td style={tdS}>{pill(item?.isActive)}</td>
                  <td style={tdS}>
                    <div style={{ display: 'flex', gap: 5 }}>
                      <button onClick={() => changeStatus(item._id, item?.isActive)} title={item?.isActive ? 'Deactivate' : 'Activate'}
                        style={{ width: 28, height: 28, borderRadius: 6, border: 'none', background: item?.isActive ? '#fee2e2' : '#dcfce7', color: item?.isActive ? '#b91c1c' : '#15803d', cursor: 'pointer', fontSize: 12 }}>
                        {item?.isActive ? '✕' : '✓'}
                      </button>
                      <button onClick={() => Navigate(`/admin/email/edit?${item._id}`)} title="Edit"
                        style={{ width: 28, height: 28, borderRadius: 6, border: 'none', background: '#eff6ff', color: '#1d4ed8', cursor: 'pointer', fontSize: 12 }}>✎</button>
                      <button onClick={() => deleteHandler(item._id)} title="Delete"
                        style={{ width: 28, height: 28, borderRadius: 6, border: 'none', background: '#fee2e2', color: '#b91c1c', cursor: 'pointer', fontSize: 12 }}>🗑</button>
                      <button onClick={() => Navigate(`/admin/email/view?${item._id}`)} title="View"
                        style={{ width: 28, height: 28, borderRadius: 6, border: 'none', background: '#f5f3ff', color: '#6d28d9', cursor: 'pointer', fontSize: 12 }}>👁</button>
                    </div>
                  </td>
                </tr>
              )) : (
                <tr><td colSpan={5} style={{ ...tdS, textAlign: 'center', padding: '48px', color: '#9aa5c0' }}>No templates found</td></tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        {allTemplates?.length > 0 && (
          <div style={{ padding: '14px 24px', borderTop: '1px solid #edf0f7', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div style={{ fontSize: 13, color: '#9aa5c0' }}>Page {pageData.page} · {pageData.perPage} per page</div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
              <Pagination itemClass="page-item" linkClass="page-link" activePage={pageData.page} itemsCountPerPage={pageData.perPage} totalItemsCount={count} pageRangeDisplayed={5} onChange={(page) => { const n = { ...pageData, page }; updateURL(n); setPageData(n); }} />
              <select onChange={(e) => { const n = { ...pageData, perPage: parseInt(e.target.value), page: 1 }; updateURL(n); setPageData(n); }} style={{ padding: '6px 10px', borderRadius: 7, border: '1px solid #e2e8f0', fontSize: 13, color: '#3a4a6a', background: '#fff', fontFamily: 'inherit' }}>
                <option value="25">25</option><option value="50">50</option><option value="75">75</option><option value="100">100</option>
              </select>
            </div>
          </div>
        )}
      </div>
      <SuccessModal message={modalData?.message} showModal={modalData?.show} setShowModal={setModalData} />
    </div>
  );
};

export default Index;
